import React from 'react';
import { Button } from 'primereact/button';
import { APP_BASE_URL } from '../../appconfig/Settings';

interface CopyAllButtonProps {
    data: any;
    onCopySuccess: () => void;
    className?: string;
    label?: string;
    type?: 'individual' | 'company';
}

const CopyAllButton: React.FC<CopyAllButtonProps> = ({ 
    data, 
    onCopySuccess, 
    className = "p-button-outline", 
    label = "Copy All",
    type = 'individual'
}) => {
    
    const formatLink = (url: string) => {
        if (!url) return '';
        let fullUrl = url.startsWith('http') ? url : `${APP_BASE_URL}/${url.startsWith('/') ? url.substring(1) : url}`;
        if (type === 'company' && !fullUrl.toLowerCase().includes('type=company')) {
            fullUrl += (fullUrl.includes('?') ? '&' : '?') + 'type=company';
        }
        return fullUrl;
    };

    const handleCopyAll = async () => {
        if (!data) return;

        const urls: string[] = [];

        if (type === 'individual') {
            if (data?.taxpayerSignUrl) {
                urls.push(`T183 Document Url : ${formatLink(data.taxpayerSignUrl)}`);
            }
            if (data?.taxpayerReadUrl) {
                urls.push(`Tax Summary Document Url : ${formatLink(data.taxpayerReadUrl)}`);
            }
            if (data?.spouseSignUrl) {
                urls.push(`Spouse T183 Document Url : ${formatLink(data.spouseSignUrl)}`);
            }
            if (data?.spouseReadUrl) {
                urls.push(`Spouse Tax Summary Document Url : ${formatLink(data.spouseReadUrl)}`);
            }
            if (data?.e_transfer_payment && data?.balance_amount) {
                urls.push(`Please make a e-transfer of ${data.balance_amount} dollars at as.nagra@gmail.com`);
            }
        } else {
            const rawSignUrl = data.signUrl || data.taxpayerSignUrl;
            if (rawSignUrl) {
                urls.push(`T183 Document Url : ${formatLink(rawSignUrl)}`);
            }
            if (data.readDocUrls && data.readDocUrls.length > 0) {
                data.readDocUrls.forEach((rawUrl: string, index: number) => {
                    const labelStr = index === 0 ? "Profit and Loss Summary" : index === 1 ? "Balance Sheet" : `Read Document ${index + 1}`;
                    urls.push(`${labelStr} Url : ${formatLink(rawUrl)}`);
                });
            }
        }

        const textToCopy = urls.join("\n\n");
        await navigator.clipboard.writeText(textToCopy);
        onCopySuccess();
    };

    return (
        <Button
            className={className}
            onClick={handleCopyAll}
        >
            {label}
        </Button>
    );
};

export default CopyAllButton;
